import * as React from 'react';

export interface SectionProps {
  children: any;
  fullWidth?: boolean;
  className?: string;
  id?: string;
}

export function Section(props: SectionProps) {
  let classes = props.fullWidth !== undefined && props.fullWidth ? ' full-width' : '';
  classes = 'section' + classes;

  if (props.className !== undefined) {
    classes += ' ' + props.className;
  }

  return (
    <div className={classes} id={props.id}>
      {props.children}
    </div>
  );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/Section.tsx